import { createReducer } from 'redux-act';
import * as actions from 'modules/actions';

export interface ILeagueLeaveReducer {
	leaving: boolean;
}

export interface IPostLeagueLeave {
	league_id: number;
}

const initialState = {
	leaving: false
};

export const leave_league = createReducer({}, initialState)
	.on(actions.postLeagueLeaveSuccess, () => ({
		leaving: true
	}))
	.on(actions.clearLeagueLeave, () => ({
		leaving: false
	}))
	.on(actions.postLeagueLeaveFailed, () => ({
		...initialState
	}));
